import React from 'react';
import PropTypes from 'prop-types';

import { PRODUCT_CLICK_LOCATION } from '@conversion/constants';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';

import { onKeyDownFunction, onKeyUpFunction } from '@utils/a11y';
import NoTaxesMessage from '@components/ProductItemPrice/components/NoTaxesMessage';
import ActionsContainer from '../Components/ActionsContainer';
import Container from '../Components/GroceriesContainer';
import GroceriesImage from '../Components/GroceriesImage';
import GroceriesTags from '../Components/GroceriesTags';
import Header from '../Components/Header';
import InfoContainer from '../Components/InfoContainer';
import Name from '../Components/GroceriesProductName';
import Price from '../Components/ProductPrice';
import PricePerUnit from '../Components/PricePerUnit';

function Groceries({
  name,
  price,
  image,
  tags,
  onClick,
  width,
  measurementUnit,
  elementId,
  priceWithoutTax,
}) {
  const isDesktopLayout = useIsDesktopLayout();

  const {
    pricePerMeasurementUnit,
    measurementUnitId,
    measurementItems,
  } = measurementUnit;
  const clickLocation = PRODUCT_CLICK_LOCATION.CARD;
  return (
    <Container
      id={elementId}
      direction="column"
      width={width}
      onClick={() => onClick(clickLocation)}
      onKeyUp={e => onKeyUpFunction(e, () => onClick(clickLocation))}
      onKeyDown={e => onKeyDownFunction(e, () => onClick(clickLocation))}
      tabIndex={0}
    >
      <ActionsContainer contained>
        <GroceriesImage name={name} image={image} toRight={false} />
        <GroceriesTags top={image}>{tags}</GroceriesTags>
      </ActionsContainer>
      <InfoContainer>
        <div>
          <Header>
            <Name>{name}</Name>
          </Header>
        </div>
        <Price>{price}</Price>
        {priceWithoutTax && (
          <NoTaxesMessage>
            {isDesktopLayout ? (
              <>
                <span>Sin impuestos</span>
                {priceWithoutTax}
              </>
            ) : (
              <div>
                <div>Sin impuestos</div>
                {priceWithoutTax}
              </div>
            )}
          </NoTaxesMessage>
        )}

        <PricePerUnit
          pricePerMeasurement={pricePerMeasurementUnit}
          measurementItems={measurementItems}
          measurementUnitId={measurementUnitId}
        />
      </InfoContainer>
    </Container>
  );
}

Groceries.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func.isRequired,
  tags: PropTypes.node,
  measurementUnit: PropTypes.object,
  elementId: PropTypes.string,
  width: PropTypes.string,
  priceWithoutTax: PropTypes.string,
};

export default Groceries;
